export enum GraphQLOperationName {
  UnknownOperation = 'UnknownOperation',
  FETCH_PRICE_LIST = 'priceList:fetchPriceList',
  FETCH_CURRENCY_RATE = 'priceList:currencyRate',
  PRODUCT_VARIANT_COST_V2 = 'eCommerceProductExpansion:destinationProductVariantsCostsV2',
}
